import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PanelUserMachineStyle } from './PanelUserMachineStyle';
import ListUserMachine from './component/ListUserMachine';
import { Button, Grid, Paper, Table, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import MigaPan from '../../app/orussystem/component/MigaPan';
import { totalDataUsers } from '../domain/api/UsersApi';
import { useDispatch } from 'react-redux';
import TablePagination from '@material-ui/core/TablePagination';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { BiSearch } from "react-icons/bi";
import theme from '../../app/config/themaConfig';


export const PanelUserMachine = (props) => {
    const classes = PanelUserMachineStyle();


    const [UsersMachine, setUsersMachine] = useState([]);
    const [isLoadUser, setIsLoadUser] = useState(true);
    const [errorUsers, setErrorUsers] = useState(false);
    // Identifica la última petición de reload: las respuestas anteriores se descartan
    const ultimaPeticion = useRef(0);
    const [page, setPage] = useState(0)
    const [size] = useState(10)
    const [totalElements, settotalElements] = useState(0)

    const location = useLocation()
    const { nameBascula, busquedaState } = location.state
    const [busqueda, setBusqueda] = useState(busquedaState || "");
    const dispatch = useDispatch();
    let { id } = useParams();
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 7 : id;

    const reload = async (idBascula, page, rowsPerPage, busqueda) => {
        const peticion = ++ultimaPeticion.current;
        setIsLoadUser(true);
        setErrorUsers(false);
        let usuarios;
        let fallo = false;
        try {
            usuarios = await totalDataUsers(dispatch, idBascula, page, rowsPerPage, busqueda);
            if (!usuarios || !Array.isArray(usuarios.content)) fallo = true;
        } catch (err) {
            fallo = true;
        }
        // Prevalece la última petición (o se descarta si el componente se desmontó)
        if (peticion !== ultimaPeticion.current) return;
        if (fallo) {
            setErrorUsers(true);
        } else {
            setUsersMachine(usuarios.content);
            settotalElements(usuarios.totalElements);
        }
        setIsLoadUser(false);
    }

    const filtrar = () => {
        reload(idBascula, 0, rowsPerPage, busqueda);
    };

    //cambio de pagina
    const handleChangePage = (event, newPage) => {
        setPage(newPage)

        reload(idBascula, newPage, rowsPerPage, busqueda)

    };
    //cambio de tamaño
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        reload(idBascula, 0, event.target.value, busqueda)
        setPage(0)

    };
    const buscador = (e) => {
        setBusqueda(e.target.value, "esta es la busqueda")

    }

    useEffect(() => () => { ultimaPeticion.current = -1; }, []);

    useEffect(async () => {
        reload(idBascula, 0, 10, busquedaState || '');

    }, []);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            filtrar();
        }
    };
    const primaryColor = theme.palette.primary.main;

    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage={`Usuarios de Bascula ${nameBascula == 'Alqueria' ? 'Alquería' : nameBascula}`}
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas/"

                >
                    Home
                </MigaPan>
            </Grid>
            <Paper className={classes.paper} >
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <Typography style={{ textAlign: 'left', fontSize: '25px', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif", marginBottom: "2%", marginTop: '2%', fontWeight: 'bold' }} color='primary'>Usuarios</Typography>
                        </Grid>
                        <Grid item xs={6} className={classes.searchContainer} >
                            <div className={classes.searchInputContainer}>
                                <input
                                    id="descripcion"
                                    type="buscador"
                                    name="descripcion"
                                    onChange={buscador}
                                    value={busqueda}
                                    onKeyPress={handleKeyPress}
                                    className={classes.searchInput}
                                    placeholder="Buscar"
                                    style={{
                                        border: `1px solid ${theme.palette.primary.main}`,
                                        borderRadius: '20px 0px 0px 20px',
                                        padding: '4px 8px',
                                        fontSize: 'inherit',
                                        outline: 'none',
                                        flex: 1,
                                    }}
                                />
                            </div>
                            <Button onClick={filtrar} disabled={isLoadUser} aria-label="Buscar" className={classes.searchButton} style={{ backgroundColor: theme.palette.primary.main }}>
                                <BiSearch />
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Table style={{ width: '100%', tableLayout: 'fixed' }}>
                                <TableHead color='primary'>
                                    <TableRow color='primary'>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '1%', width: '11%', color: primaryColor }}>Identificacion</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '2%', width: '10%', color: primaryColor }}>Nombre</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '5%',  color: primaryColor }}>Celular</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '6%', color: primaryColor }}>Género</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '7%', color: primaryColor }}>Imc</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '8%', color: primaryColor }}>Porcentaje de Grasa</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '6%', color: primaryColor }}>Peso</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '6%', color: primaryColor }}>Altura</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '5%', color: primaryColor }}>Presión Arterial (mmHg) </TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '10%', color: primaryColor }}>Fecha Última Medicion</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '16%', color: primaryColor }}>Acciones</TableCell>

                                    </TableRow>
                                </TableHead>
                            </Table>

                        </Grid>
                        <Grid item xs={12}>
                            <ListUserMachine
                                rows={UsersMachine}
                                isLoadUser={isLoadUser}
                                errorUsers={errorUsers}
                                page={page}
                                size={size}
                                totalElement={totalElements}
                                setPage={setPage}
                                nameBascula={nameBascula}
                                idBasula={idBascula}
                                primaryColor={primaryColor}
                                busqueda={busqueda}

                            />
                        </Grid>
                    </Grid>
                    <Paper className={classes.paper}>
                        <TablePagination
                            component="div"
                            count={totalElements}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Datos por página:"
                            style={{ color: primaryColor }}
                        />
                    </Paper>
                </Grid>
            </Paper>
        </>


    )



}